import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import * as MapboxGl from 'mapbox-gl';
import { NgxMapboxGLModule } from 'ngx-mapbox-gl';

import { CopyToClipboardDirective } from 'src/app/core/directives/copy-to-clipboard.directive';
import { ShareDirectivesModule } from 'src/app/core/directives/directives.module';
import { MobileOperatorImgDirective } from 'src/app/core/directives/mobile-operator-img.directive';
import { EnumToTextConvertorPipe } from 'src/app/core/pipes/enum-text.pipe';
import { NumberSeparatorPipe } from 'src/app/core/pipes/number.separator.pipe';
import { ConsoleService } from 'src/app/core/services/console.service';
import { TranslationModule } from 'src/app/i18n';
import { environment } from 'src/environments/environment';
import { MaterialModule } from '../../modules/material/material.module';
import { SmartSendConfirmationMapComponent } from './smart-send-confirmation-map.component';
import { SmsPriceViewComponent } from './sms-price-view/sms-price-view.component';

if (MapboxGl.getRTLTextPluginStatus() === 'unavailable')
  MapboxGl.setRTLTextPlugin(
    'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.0/mapbox-gl-rtl-text.js',
    (err: any) => {
      err && ConsoleService.error('', err);
    },
    true
  );

@NgModule({
  declarations: [SmartSendConfirmationMapComponent, SmsPriceViewComponent],
  imports: [
    CommonModule,
    MaterialModule,
    NgbModule,
    FormsModule,
    ShareDirectivesModule,
    ReactiveFormsModule,
    TranslationModule,
    NumberSeparatorPipe,
    MobileOperatorImgDirective,
    EnumToTextConvertorPipe,
    NgxMapboxGLModule.withConfig({
      accessToken: environment.mapBoxToken,
    }),
  ],
  exports: [SmartSendConfirmationMapComponent],
  providers: [CopyToClipboardDirective],
})
export class SmartSendConfirmationMapModule {}

